import { InformationCircleBold } from '@ha/icons';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { Tooltip, IconButton } from '@hbf/dsl';

const useStyles = makeStyles()(theme => ({
  icon: {
    fontSize: theme.typography.body1.fontSize,
  },
  button: {
    paddingTop: 0,
  },
}));

interface Props {
  colorType?: 'disabled' | 'inherit';
  onOpen?: (event: React.ChangeEvent<{}>) => void;
  tooltip: NonNullable<React.ReactNode>;
}

const TextTooltip: React.FC<Props> = ({
  colorType = 'disabled',
  tooltip,
  ...props
}) => {
  const { classes } = useStyles();

  return (
    <Tooltip title={tooltip} placement="top" leaveTouchDelay={5000} {...props}>
      <IconButton size="small" disableRipple className={classes.button}>
        <InformationCircleBold className={classes.icon} color={colorType} />
      </IconButton>
    </Tooltip>
  );
};

export { TextTooltip };
